import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  background-color: var(--secondary-color);
  border-radius: 5px 5px 50px 5px;
  min-width: 252px;
  padding: 2rem 1rem 5px;
  position: relative;
  margin: 0.5rem;
  min-width: 280px;
  max-width: 390px;
  .buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  @media (min-width: 768px) {
    width: 390px;
    height: 240px;
  }
`;
export const Title = styled.p`
  color: var(--details-color);
  margin-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 230px;
  font-size: 1.2rem;
  font-weight: bolder;
  @media (min-width: 768px) {
    max-width: 280px;
  }
`;
export const Type = styled.p`
  color: var(--primary-color);
  margin-bottom: 0.5rem;
`;
export const Description = styled.p`
  margin-bottom: 0.5rem;
  color: var(--primary-color);
  font-size: 0.75rem;
  font-weight: lighter;
  max-width: 250px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  @media (min-width: 768px) {
    max-width: 310px;
  }
`;
export const GuestsList = styled.ul``;
export const Guest = styled.li``;
export const LinkTo = styled(Link)`
  color: var(--primary-color);
  text-decoration: none;
  &:visited {
    color: var(--primary-color);
  }
  &:hover {
    color: var(--primary-color);
    text-decoration: underline;
  }
  &:active {
    color: var(--primary-color);
  }
`;
